import React, { Component } from 'react';
import { OverlayTrigger, Tooltip, Glyphicon } from 'react-bootstrap';

class BonusDetails extends Component {
  render() {
    const { incentive } = this.props;
    const submissions = Number(incentive.bonus_packs_sold);
    const maxSubmissions = Number(incentive.maximum_bonus_submissions);

    return (
      <div className="performance-details bonus-details">
        <div className="text-center">
          <div className="bonus-points">
            <p className="bonus-text">BONUS</p>
            <div className="bonus-value"><strong>{incentive.bonus_points_awarded}</strong></div>
          </div>
          {[...maxSubmissions].map((item, i) => (
            <span
              key={item}
              className={`glyphicon glyphicon-star star ${i < submissions ? 'submitted' : 'unsubmitted'}`}
            />
          ))}
          <OverlayTrigger
            overlay={(
              <Tooltip className="tooltip" id="bonus-tooltip">
                Please note, bonus points are awarded on a personal level and do not go towards outlet ignite levels
              </Tooltip>
            )}
            placement="right"
          >
            <Glyphicon className='bonus-tooltip' glyph="info-sign"/>
          </OverlayTrigger>
        </div>
        <div className="clear-fix"></div>
      </div>
    );
  }
}

export default BonusDetails;



// WEBPACK FOOTER //
// ./src/components/store-performance/sell-it/bonus-details.jsx